import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { IElixir } from "../apis/elixirsAPI/types"
import { getAllElixirs } from "../apis/elixirsAPI/index"

interface ElixirsState {
  data: IElixir[]
  isLoading: boolean
  error: any
}

const initialState: ElixirsState = {
  data: [],
  isLoading: false,
  error: null
}

const elixirSlice = createSlice({
  name: "elixir",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(getAllElixirs.matchFulfilled, (state, { payload }) => {
      state.data = payload
    })
  }
})

export const { setLoading, setError } = elixirSlice.actions

export default elixirSlice
